module.exports = __webpack_public_path__ + "static/img/05.7a80778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/05.jpg
// module id = 379
// module chunks = 1